<template>
  <div id="gameView">

  <!-- object -->
  <div v-for="item in currentRoomData" :key="item.id" >
  <div class="roomTitle"> {{item.room.title}} </div>
    <div class="objects" :key="item.id"
    v-for="(item, roomindex) in item.room.object"
    v-on:click="interactWithObjectInRoom(item, roomindex)"
    :class="[item.taken ? 'hidden' : '', 'item']"
    :style="{
            position: ['absolute'],
            left: item.position[0] + 'px',
            top: item.position[1] + 'px',
            width: item.position[2] + 'px',
            height: item.position[3] + 'px'
          }
    ">
     <img :src="item.img"/>
     </div>
  </div>
  <!-- object -->


  </div>
</template>

<script>
import { interAction } from '@/store/util/naming'
import { objectTyp } from '@/store/util/naming'
import { mapGetters } from 'vuex'
export default {
  name: 'gameView',
  props: ['currentRoomData'],
  computed:{
    ...mapGetters({
       userdata: 'getInventar',
       currentUserAction: 'getAction'
    }),

  },
  data(){
    return{

    }
  },
  methods:{

    //store inventar to action
    getListOfInventarObjects(){

      // store all inventar items to an array
      var invenarArray = []
      this.userdata.forEach(function (valuesArray) {
        invenarArray.push(valuesArray.value)
      });
      return invenarArray
    },

    // interact with objects in the game
    interactWithObjectInRoom(item, index){

      const { keyid, kind, title, value, img, description, linkedroomid, readonly } = item

      var text, desc, path
      var route = this.$route.path
      var userAction = this.currentUserAction
      var keyisneeded = (keyid.length > 0 ? true: false)
      var invenarArray = this.getListOfInventarObjects()



      // switch kind -> object, door, human
      switch (kind) {
        case objectTyp.object:{
          if (userAction == interAction.take) {

            // check if item is readonly
            if (readonly == true) {
              this.printToActionLog("Da steht was geschrieben...",undefined)

            // object is takable
            }else{

              // add taken object to user inventar
              this.$store.commit('addToInventar',{
                title: title,
                value: value,
                img: img,
                description: description
              });

              // set object as taken (true) (update room state)
              this.$store.commit('setRoomObjectState',{
                // update room with id
                roomid:this.$route.params.id,
                // update door with id
                objectid: index
              })

            }

          }
          else if (userAction == interAction.watch){
              text = title + ":"
              desc = description
              this.printToActionLog(text,desc)
          }
          else if (userAction == interAction.talk){
              text = "Damit kannst du nicht reden..."
              this.printToActionLog(text,desc)
          }
        }
        break;
        case objectTyp.human:{
          if (userAction == interAction.take) {
              text = "Das geht nicht..."
              this.printToActionLog(text,desc)
          }
          else if (userAction == interAction.watch){
              text = "Sieht aus wie " + title + "..."
              this.printToActionLog(text,desc)
          }
          else if (userAction == interAction.talk){
              desc = item.description
              this.printToActionLog(text,desc)
          }
        }
        break;
        case objectTyp.door:{
          if ( keyisneeded && invenarArray.includes(keyid) || keyisneeded == false ) {
              // no key needed
              path = '/'+ linkedroomid
              this.printToActionLog("...",undefined)
          }else{
              // key needed
              if (keyisneeded && !invenarArray.includes(keyid)) {
                // check selected action
                if (userAction == interAction.take) {
                    text = "Diese Türe kannst Du nicht mitnehmen..."
                    this.printToActionLog(text,desc)
                }
                else if (userAction == interAction.watch){
                    text = title + ": "
                    desc = description
                    this.printToActionLog(text,desc)
                }
                else if (userAction == interAction.talk){
                    text = "Damit kannst du nicht reden..."
                    this.printToActionLog(text,desc)
                }
                // route to self
                path = ''+ route
              }
          }
          this.$router.push(path)

        }
        break;
        default:
      }
    },
    printToActionLog(text, desc){
      text = text === undefined ? "" : text
      desc = desc === undefined ? "" : desc
      document.getElementById("actionLog").innerHTML = text + " " + desc
    }

  }
}
</script>
<style lang="scss" scoped>
*
{
  ::-moz-selection { background: transparent; }
  ::selection { background: transparent; }
}
.console{
  position: absolute;
  top:0;
  right:0;
  z-index: 10;
}
.roomTitle{
  position: absolute;
  padding: 10px;
}

.objects{
  position: absolute;
  font-size: 14px;
  border: 0px solid black;
  cursor:zoom-in;
  &.hidden{
    display: none;
  }
  &:hover{
    //background-color: rgba(0,0,0,0.1);
  }
  img{
    width: 100%;
    height: auto;
  }
}
</style>
